<template>
    <div class="not-found">
        <div>
            <span>404</span>
            <p>{{ $t('common.pageNotFoundMessage') }}</p>
        </div>
    </div>
</template>

<script>
export default {};
</script>
